// Moment formats - never format a date with an inline literal. Charts go
// through `toChartDateFormat()`; `\u00A0` keeps the weekday on the date.
export const FormatConfigurations = {
  DateFormat: 'D.M.YYYY',
  DateTimeFormat: 'D.M.YYYY HH:mm',
  TimeFormat: 'HH:mm',
  ShortDateTimeFormat: 'D.M. HH:mm',
  ShortDateTimeWithSecondsFormat: 'D.M. HH:mm:ss',
  // Map popup header: the date and the time are two separately styled spans.
  PopupDateFormat: 'D. M. YYYY',
  TimeWithSecondsFormat: 'HH:mm:ss',
  WeekdayShortDateFormat: 'dd\u00A0D.M.',
  WeekdayShortDateTimeFormat: 'dd\u00A0D.M. HH:mm',
  WeekdayDateFormat: 'dd\u00A0D.M.YYYY',
  CalendarMonthYearFormat: 'MMMM YYYY',
  TableMonthYearFormat: 'M/YYYY',
  DateFormatForRequest: 'YYYY-MM-DD',
};
